<div class="titulo_seccion">
    {{ 'clientes.titulo' | translate }}
</div>
<p>
  clientes works!
</p>
<app-main-dash></app-main-dash>